/**
 * Canal de transcrição por anexo de TEXTO no composer
 * (spec-010-r2-guiada-pelo-agente-com-transcricao, [T006], US-4).
 *
 * Irmão de `apiFeeFixoCarteiraChat`: mesmo racional (REST autenticado
 * próprio, fora da porta única de IA — o arquivo já É a transcrição, o
 * modelo não intermedia o upload), canal DIFERENTE e backend de OUTRO
 * módulo (`aawz_transcriptions`). Aqui não há OCR nem polling — a resposta
 * volta pronta na mesma chamada
 * (`resource_transcriptions_upload_texto.py`): a transcrição já está
 * gravada e ligada a `id_cliente_app` quando o `status` volta 200.
 */
import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { aawzTranscriptions as endpoint } from '@modules/aawz-intelligence-v2/constants/URL'

const MSG_SEM_CLIENTE =
  'Escolha o cliente que vai receber esta transcrição antes de enviar o arquivo.'
const MSG_SEM_ARQUIVO =
  'Selecione o arquivo de transcrição (.txt, .md, .vtt ou .docx) para enviar.'
const MSG_ERRO_UPLOAD =
  'Não foi possível enviar a transcrição. Tente novamente mais tarde ou contate o suporte.'

class ApiTranscricaoUploadTexto extends APITemplate {
  /**
   * Envia o arquivo de transcrição e recebe o `transcription_id` já gravado.
   *
   * @param {Object} opts
   * @param {number|string} opts.idClienteApp `app_clientes.id` — obrigatório
   *   (o backend recusa 400 sem ele; a transcrição anexada no chat é sempre
   *   sobre UM cliente em foco).
   * @param {File} opts.arquivo O `.txt`/`.md`/`.vtt`/`.docx` anexado.
   * @param {string} [opts.titulo] Título opcional; sem ele o backend deriva
   *   do nome do arquivo.
   * @returns {Promise<Object>} `{status, message, value: {transcription_id,
   *   n_segmentos, titulo, plataforma}}`.
   */
  async upload({ idClienteApp, arquivo, titulo } = {}) {
    // Guards ANTES de montar o corpo — mesma régua de `apiFeeFixoCarteiraChat`.
    if (!idClienteApp) {
      return this.buildErrorResponse({
        message: MSG_SEM_CLIENTE,
        value: null,
        status: 400,
      })
    }
    if (!arquivo) {
      return this.buildErrorResponse({
        message: MSG_SEM_ARQUIVO,
        value: null,
        status: 400,
      })
    }

    const dados = { file: arquivo, id_cliente_app: idClienteApp }
    if (titulo) dados.titulo = titulo

    const r = await con.post(endpoint.uploadTexto, dados)
    return (
      r ||
      this.buildErrorResponse({
        message: MSG_ERRO_UPLOAD,
        value: null,
      })
    )
  }
}

const apiTranscricaoUploadTexto = new ApiTranscricaoUploadTexto()
export { apiTranscricaoUploadTexto }
export default apiTranscricaoUploadTexto
